var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('About'),_c('v-divider',{staticClass:"mt-6 mb-5 mx-auto"}),_c('DemoProjectList'),_c('v-divider',{staticClass:"mt-8 mb-3 mx-auto"}),_c('Contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }